import { FC } from 'react';
import HousemateDetail from './HousemateDetail';
import UseHousemateDetail from './UseHousemateDetail';

const HousemateDetailContainer: FC = () => {
  return <HousemateDetail {...UseHousemateDetail()} />;
};

export default HousemateDetailContainer;
